import LayoutOverlay from 'lqa-ui/lib/Layouts/Overlay';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { ScrollLockingOverlay } from 'components/scrollLockingOverlay/ScrollLockingOverlay';
import { IButtonIconProps } from 'lqa-ui/lib/Components/ButtonIcon/index';
import { markLqaAcademyModalSeen } from 'helpers/LqaAcademyNewsPopUpDisplay';

export interface IModal {
    title: string;
    children: ReactElement;
    size?: 'small' | 'wide' | 'default' | 'max' | 'medium';
    buttonIcons?: IButtonIconProps[];
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    outSideClickClose?: boolean;
}

const Modal = (props: IModal) => {
    const {title, children, size, buttonIcons, setIsOpen, isOpen, outSideClickClose} = props;
    const {t} = useTranslation();
    const history = useHistory();

    async function handleClose() {
        markLqaAcademyModalSeen();
        setIsOpen(false);
      }

    return (
        <ScrollLockingOverlay
            isOpen={isOpen}
            layout="focusview"
            doClose={(e) => {
                e.preventDefault();
                setIsOpen(false);
            }}
        >
            <LayoutOverlay
                title={t(title)}
                size={size || 'small'}
                buttonIcons={buttonIcons}
                outsideClickClose={outSideClickClose || false}
                outsideClickClosefn={handleClose}
            >
                {children}
            </LayoutOverlay>
        </ScrollLockingOverlay>
    );
};

export default Modal;
